import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";
import Constants from "../../services/constants";
import { hideLoader, showLoader } from "./loaderSlice";
import { showToast } from "./toastSlice";

const initialState = {
  logs: [],
  loading: false,
  error: null,
};

export const getActivityLogs = createAsyncThunk(
  "activityLogs/getLogs",
  async (_, { dispatch, getState }) => {
    const state = getState();
    const activeOrg = state.org.active;

    if (!activeOrg?.id) {
      dispatch(
        showToast({
          severity: "error",
          summary: "No active organization found",
        })
      );
      return Promise.reject("No active organization found");
    }

    try {
      const res = await api(
        "get",
        `${Constants.END_POINT.events}organization/${activeOrg.id}`
      );
      if (res?.success && Array.isArray(res?.data)) {
        return res.data;
      }
      throw new Error(res.message || "Failed to fetch activity logs");
    } catch (error) {
      dispatch(
        showToast({
          severity: "error",
          summary: "Failed to fetch activity logs",
          detail: error.message,
        })
      );
      throw error;
    } finally {
    }
  }
);

const activityLogsSlice = createSlice({
  name: "activityLogs",
  initialState,
  reducers: {
    clearLogs: (state) => {
      state.logs = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActivityLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivityLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload;
        state.error = null;
      })
      .addCase(getActivityLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearLogs } = activityLogsSlice.actions;
export default activityLogsSlice.reducer;
